import AssessmentPage from "./AssessmentPage";
import { useAssessment } from "../../providers/AssessmentProvider";
import { useAssessmentTabs } from "../../providers/AssessmentTabsProvider";
import AssessmentReviewPage from "./AssessmentReviewPage";
import { useEffect } from "react";
import { usePatientAndAssessmentDataHelper } from "../../providers/PatientAndAssessmentDataHelperProvider";
import { useLocation } from "react-router-dom";
import { useAssessmentWalkthrough } from "../../providers/AssessmentWalkthroughProvider";
import ExpertModeAssessmentPage from "./ExpertModeAssessment/ExpertModeAssessmentPage";
import { useGuidedMode } from "../../providers/GuidedModeProvider";

function Assessment() {
  const { guidedMode, showOrHideGuidedMode, guidedModeLoading } =
    useGuidedMode();
  const { getPatientData, getAssessmentDetails, checkUserDetails } =
    usePatientAndAssessmentDataHelper();

  const { showOrHideAssessmentWalkthrough, showOrHideCheckBox } =
    useAssessmentWalkthrough();

  const { assessment, startNewAssessment } = useAssessment();
  const { selectedTab, updateSelectedTab } = useAssessmentTabs();
  const location = useLocation();

  const assessmentSections = Object.keys(assessment);

  const getPatientAndAssessmentId = () => {
    const parts = location.pathname.substring(1).split("/");
    return {
      patientId: parts[1],
      assessmentId: parts.length > 3 ? parts[parts.length - 1] : null,
    };
  };

  useEffect(() => {
    if (!guidedModeLoading) {
      if (guidedMode === true) {
        showOrHideGuidedMode(false);
      } else if (guidedMode === false) {
        showOrHideGuidedMode(false);
      }
    }
    const { patientId, assessmentId } = getPatientAndAssessmentId();

    getPatientData(patientId);

    const loadAssessment = async () => {
      if (assessmentId) {
        await getAssessmentDetails(patientId, assessmentId);
      } else {
        startNewAssessment();
      }
      updateSelectedTab(0);
    };

    loadAssessment();

    const handleUserData = async () => {
      const userData = await checkUserDetails();
      if (userData.status === 200) {
        const checkboxValue = userData.data.doNotShowAssessmentWalkthrough;
        {
          guidedMode === null
            ? showOrHideGuidedMode(true)
            : showOrHideGuidedMode(false);
        }
        showOrHideCheckBox(!checkboxValue);
        showOrHideAssessmentWalkthrough(!checkboxValue);
      }
    };

    handleUserData();
  }, [guidedModeLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderAssessmentPage = () => {
    if (guidedMode) {
      switch (selectedTab) {
        case 1:
          return <AssessmentPage section={assessmentSections[1]} />;
        case 2:
          return <AssessmentPage section={assessmentSections[2]} />;
        case 3:
          return <AssessmentReviewPage />;
        default:
          return <AssessmentPage section={assessmentSections[0]} />;
      }
    }
    return <ExpertModeAssessmentPage />;
  };
  return <div>{renderAssessmentPage()}</div>;
}

export default Assessment;
